import LocalizedStrings from 'react-localization';
import en from '@pharmaplan/common/localization/en';
import fr from '@pharmaplan/common/localization/fr';

const strings = new LocalizedStrings({
  en,
  fr,
});

export default strings;
